import { render, staticRenderFns } from "./Assistencia.vue?vue&type=template&id=42b4560a&"
import script from "./Assistencia.vue?vue&type=script&lang=js&"
export * from "./Assistencia.vue?vue&type=script&lang=js&"
import style0 from "./Assistencia.vue?vue&type=style&index=0&id=42b4560a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports